import { render, staticRenderFns } from "./SingleReservesModal.vue?vue&type=template&id=28d75360&scoped=true&"
import script from "./SingleReservesModal.vue?vue&type=script&lang=js&"
export * from "./SingleReservesModal.vue?vue&type=script&lang=js&"
import style0 from "./SingleReservesModal.vue?vue&type=style&index=0&id=28d75360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d75360",
  null
  
)

component.options.__file = "SingleReservesModal.vue"
export default component.exports